import {
  TechnicalReportListItemInterface,
  TechnicalReportSignatureInterface,
  TechnicalReportSignatureRoleValue
} from "../../common/interfaces";
import api from "../../services/api";

export interface TechnicalReportListResponse {
  items: TechnicalReportListItemInterface[];
  meta: {
    totalItems: number;
    itemCount: number;
    itemsPerPage: number;
    totalPages: number;
    currentPage: number;
  };
}

export async function listTechnicalReports(params: {
  page?: number;
  limit?: number;
  search?: string;
}): Promise<TechnicalReportListResponse> {
  const { data } = await api.get("/technical-reports", {
    params: {
      page: params.page,
      limit: params.limit,
      search: params.search?.trim() || undefined
    }
  });
  return data;
}

export async function listSignatures(
  reportId: number
): Promise<TechnicalReportSignatureInterface[]> {
  const { data } = await api.get(`/technical-reports/${reportId}/signatures`);
  return data;
}

export async function saveSignature(
  reportId: number,
  role: TechnicalReportSignatureRoleValue,
  payload: {
    signer_name: string;
    signer_document?: string;
    image_base64: string;
  }
): Promise<TechnicalReportSignatureInterface> {
  const { data } = await api.put(
    `/technical-reports/${reportId}/signatures/${role}`,
    payload
  );
  return data;
}

export async function deleteSignature(
  reportId: number,
  role: TechnicalReportSignatureRoleValue
): Promise<void> {
  await api.delete(`/technical-reports/${reportId}/signatures/${role}`);
}
